<div class="each-section m-b-10 flex flex-col" *ngIf="true">
  <header class="flex flex-row justify-between items-center" *ngIf="true">
    <!--    <div class="title">-->
    <!--      {{section?.title}}-->
    <!--    </div>-->
    <div class="right-section m-r-9">
      <button mat-icon-button [matMenuTriggerFor]="actionMenu" class="">
        <mat-icon class="s-20">more_horiz</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
        <!--<button mat-menu-item class="" (click)="openDetailsAndInstructions(false)"><span>Details & Instructions</span>
        </button>-->
      </mat-menu>
    </div>
  </header>
  <div class="details">
    <particle-flow-chart-response #flowChartResponse [section]="section" [surveyId]="surveyId"
                                  [sourceType]="sourceType" [rowItem]="rowItem"
                                  [fieldDefinitions]="fieldDefinitions"></particle-flow-chart-response>
  </div>
</div>

